import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { OrderParameters } from "_shared/_api/queries/ordering/order-parameters";

export enum FeeSchedulesOrderField {
    Name = "Name",
    CreatedDate = "CreatedDate",
}

export default class FeeSchedulesOrderParameters extends OrderParameters {
    public static fromSearchParams(
        searchParams: URLSearchParams,
        options?: {
            orderByParamName: string;
            orderDirParamName: string;
        }
    ): FeeSchedulesOrderParameters {
        const opts = options ?? {
            orderByParamName: "orderBy",
            orderDirParamName: "orderDir",
        };

        let orderBy = FeeSchedulesOrderField.CreatedDate;
        let orderDir = OrderDirection.Descending;

        const orderByParam = searchParams.get(opts.orderByParamName);
        const orderDirParam = searchParams.get(opts.orderDirParamName);

        if (orderByParam) {
            const enumValue = Object.values(FeeSchedulesOrderField).find(
                (field) => field.toLowerCase() === orderByParam.toLowerCase()
            );
            if (enumValue) {
                orderBy = enumValue;
            }
        }

        if (orderDirParam) {
            const enumValue = Object.values(OrderDirection).find(
                (field) => field.toLowerCase() === orderDirParam.toLowerCase()
            );
            if (enumValue) {
                orderDir = enumValue;
            }
        }

        return new FeeSchedulesOrderParameters({ orderBy, orderDir });
    }

    public orderBy: FeeSchedulesOrderField;
    public orderDir: OrderDirection;

    public constructor(params: { orderBy: FeeSchedulesOrderField; orderDir: OrderDirection }) {
        super();
        this.orderBy = params.orderBy;
        this.orderDir = params.orderDir;
    }

    public isEqualTo(other: FeeSchedulesOrderParameters): boolean {
        if (!other || !(other instanceof FeeSchedulesOrderParameters)) return false;
        return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
    }
}